// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bank-dropdown-custom {
  position: relative;
  width: 100%;
  min-height: 100%;
}

.bank-dropdown-selected {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  padding: 4px 24px 4px 8px;
  position: relative;
}

.bank-name-display {
  font-size: 16px;
  font-weight: 500;
  color: #27272a;
  line-height: 1.2;
}

.bank-iban-display {
  font-size: 14px;
  color: #6c757d;
  line-height: 1.2;
  margin-top: 2px;
}

.bank-dropdown-arrow {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  pointer-events: none;
  font-size: 14px;
}

.bank-dropdown-options {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 300px;
  background: white;
  border: 1px solid #019440;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  margin-top: 4px;
}

.bank-dropdown-option {
  padding: 12px 14px;
  cursor: pointer;
  border-bottom: 1px solid #e4e4e7;
  transition: background-color 0.2s;
}

.bank-dropdown-option:last-child {
  border-bottom: none;
}

.bank-dropdown-option:hover {
  background-color: #f8f9fa;
}

.bank-dropdown-option.selected {
  background-color: #e8f5e9;
}

.bank-dropdown-option-name {
  font-size: 16px;
  font-weight: 500;
  color: #27272a;
  line-height: 1.3;
  margin-bottom: 2px;
}

.bank-dropdown-option-iban {
  font-size: 14px;
  color: #6c757d;
  line-height: 1.3;
}

.bank-dropdown-options::-webkit-scrollbar {
  width: 6px;
}

.bank-dropdown-options::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.bank-dropdown-options::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.bank-dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #555;
}

`, "",{"version":3,"sources":["webpack://./src/Pages/HGO/Dashboard/MonazamAccount/MonazamAccountComponents/BankDropdown.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".bank-dropdown-custom {\n  position: relative;\n  width: 100%;\n  min-height: 100%;\n}\n\n.bank-dropdown-selected {\n  width: 100%;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  cursor: pointer;\n  padding: 4px 24px 4px 8px;\n  position: relative;\n}\n\n.bank-name-display {\n  font-size: 16px;\n  font-weight: 500;\n  color: #27272a;\n  line-height: 1.2;\n}\n\n.bank-iban-display {\n  font-size: 14px;\n  color: #6c757d;\n  line-height: 1.2;\n  margin-top: 2px;\n}\n\n.bank-dropdown-arrow {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6c757d;\n  pointer-events: none;\n  font-size: 14px;\n}\n\n.bank-dropdown-options {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  min-width: 300px;\n  background: white;\n  border: 1px solid #019440;\n  border-radius: 4px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  max-height: 200px;\n  overflow-y: auto;\n  margin-top: 4px;\n}\n\n.bank-dropdown-option {\n  padding: 12px 14px;\n  cursor: pointer;\n  border-bottom: 1px solid #e4e4e7;\n  transition: background-color 0.2s;\n}\n\n.bank-dropdown-option:last-child {\n  border-bottom: none;\n}\n\n.bank-dropdown-option:hover {\n  background-color: #f8f9fa;\n}\n\n.bank-dropdown-option.selected {\n  background-color: #e8f5e9;\n}\n\n.bank-dropdown-option-name {\n  font-size: 16px;\n  font-weight: 500;\n  color: #27272a;\n  line-height: 1.3;\n  margin-bottom: 2px;\n}\n\n.bank-dropdown-option-iban {\n  font-size: 14px;\n  color: #6c757d;\n  line-height: 1.3;\n}\n\n.bank-dropdown-options::-webkit-scrollbar {\n  width: 6px;\n}\n\n.bank-dropdown-options::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.bank-dropdown-options::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 3px;\n}\n\n.bank-dropdown-options::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
